<div class="content">
  <div class="modal-header">
    <h4 class="modal-title full-width ">
      <h3 class="popupHeaderTxt">{{ 'LABELS.SELECT_DEDUCTION' | translate}}</h3>
    </h4>
    <!--button type="button" class="close invoice-timeline-view-close-btn" aria-label="Close"
      (click)="activeModal?.close(null)">
      <span aria-hidden="true">&times;</span>
    </button-->
  </div>
  <div class="modal-body">
    <!-- <div class="row text-center">
      <div class="col"> -->
        <div style="overflow-y: auto; overflow-x: hidden; padding-bottom: 10px;  max-height: 300px;">
          <div class="row">
            <div class="col-12 text-center">
              <!-- <h6>{{ 'LABELS.SELECT_REASON_AND_ENTER' | translate}}
              <small>{{ 'LABELS.MARKED_ARE_MANDATORY' | translate}}</small></h6> -->
              <h6>{{ 'LABELS.SELECT_APPLICABLE_PARTIALPAY_REASON_AND_ENTER' | translate}}</h6>
            </div>
          </div>
          <form #invoicePayAmtForm="ngForm" (ngSubmit)="formSubmitted = true;setPayamount(invoicePayAmtForm)">
            <ng-container *ngFor="let invoice of payData.payData.invoiceData.invoices;">
              <div  *ngIf="invoice.enableDeduction">
                <invoice-pay-deductions [invoice]="invoice" [payData]="payData.payData"></invoice-pay-deductions>
              </div>
            </ng-container>
          </form>
        </div>
      <!-- </div>
    </div> -->
  </div>
  <!-- Sticky totals strip: pinned above the buttons, outside the scroll region -->
  <div class="deduction-totals-strip">
    <div class="deduction-total-item">
      <span class="deduction-total-label">{{ 'LABELS.TOTAL_DEDUCTIONS' | translateWithDefault : 'Total Deductions' }}</span>
      <span class="deduction-total-value">{{payData.payData.totalDeductionForAllInvoicesFormatted}}</span>
    </div>
    <div class="deduction-total-item text-end">
      <span class="deduction-total-label">{{ 'LABELS.NET_AMOUNT_DUE' | translateWithDefault : 'Net Amount Due' }}</span>
      <span class="deduction-total-value deduction-total-strong">{{payData.payData.netAmountDueFormatted}}</span>
    </div>
  </div>
  <div class="modal-footer deduction-footer">
    <button id="btnClear" class="btn btn-link deduction-clear-all" (click)="clearDeductions()">
      {{'LABELS.CLEAR_ALL' | translate}}
    </button>
    <div class="deduction-footer-actions">
      <button id="btnClose" class="btn btn-outline-dark" (click)="closeModal()">
        {{ 'LABELS.CANCEL' | translate}}
      </button>
      <button id="btnSetPayAmount" class="btn deduction-done-btn" (click)="setPayableAmountAfterDeductions()"
        [disabled]="formError">
        {{ 'LABELS.DONE' | translate}}
      </button>
    </div>
  </div>
</div>
